import { UserState } from './types';
import User from '../../types/User';
import Area from '../../types/area';
import CurrentRoute from '@/src/auth/types/currentRoute';

export default {
  setUser(state: UserState, user: User) {
    state.user = user;
  },
  setAreas(state: UserState, areas: Area[]) {
    state.areas = areas;
  },
  setCurrentRoute(state: UserState, currentRoute: CurrentRoute) {
    state.currentRoute = currentRoute;
  }
};
